export default [
    {
        path: 'relatorio-saida',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-saida' */
            '@/views/almoxarifado/relatorio-saida/Index'
        ),
        redirect: 'relatorio-saida/index',
        children: [
            {
                name: 'almoxarifado-relatorio-saida-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-saida' */
                    '@/views/almoxarifado/relatorio-saida/List.vue'
                ),
            },
        ],
    },
]